<BolideLoader v-if="is_redirecting" />

<main class="auth-page min-vh-100 bg-light">
  <div class="container min-vh-100 d-flex align-items-center py-5">
    <div class="auth-panel row g-0 w-100 justify-content-center shadow-lg rounded-4 overflow-hidden bg-white">
      <section class="auth-brand-panel col-lg-6 text-white p-4 p-md-5 d-none d-lg-flex flex-column">
        <router-link to="/login" class="d-inline-flex bg-white rounded-3 p-3 shadow" aria-label="Department of Basic Education login">
          <span class="auth-logo d-block" aria-hidden="true"></span>
        </router-link>

        <div class="my-auto py-5">
          <p class="text-uppercase small text-white-50 fw-semibold mb-2">Department of Basic Education</p>
          <h1 class="display-6 fw-bold mb-3">Education progress data, ready when you are.</h1>
          <p class="text-white-50 mb-0">
            Sign in to access national programme progress, implementation, compliance, and achievement insights.
          </p>
        </div>
      </section>

      <section class="col-lg-6 p-4 p-md-5 d-flex align-items-center">
        <div class="mx-auto w-100 py-lg-4" style="max-width: 28rem;">
          <router-link to="/login" class="d-flex d-lg-none justify-content-center mb-4" aria-label="Department of Basic Education login">
            <span class="auth-logo auth-logo-navbar d-block" aria-hidden="true"></span>
          </router-link>

          <h2 class="h3 fw-bold mb-2">Welcome back</h2>
          <p class="text-secondary mb-4">Enter your DBE dashboard details to continue.</p>

          <SnackbarMessage
            :error-message="error_message"
            :success-message="success_message"
            @dismiss-error="error_message = ''"
            @dismiss-success="success_message = ''"
          />

          <div v-if="is_loading" class="d-flex align-items-center justify-content-center gap-2 text-secondary py-4">
            <span class="spinner-border spinner-border-sm text-primary" aria-hidden="true"></span>
            <span>Authenticating...</span>
          </div>

          <form v-if="!is_loading" @submit.prevent="handle_login">
            <div class="mb-3">
              <label class="form-label fw-semibold small" for="login-email">Email address</label>
              <div class="input-group">
                <span class="input-group-text bg-white text-secondary">
                  <i class="bi bi-envelope" aria-hidden="true"></i>
                </span>
                <input
                  id="login-email"
                  v-model="credentials.email"
                  type="email"
                  class="form-control"
                  placeholder="name@education.gov.za"
                  autocomplete="email"
                  required
                />
              </div>
            </div>

            <div class="mb-4">
              <label class="form-label fw-semibold small" for="login-password">Password</label>
              <div class="input-group">
                <span class="input-group-text bg-white text-secondary">
                  <i class="bi bi-lock" aria-hidden="true"></i>
                </span>
                <input
                  id="login-password"
                  v-model="credentials.password"
                  :type="password_input_type"
                  class="form-control"
                  placeholder="Enter your password"
                  autocomplete="current-password"
                  required
                />
                <button
                  type="button"
                  class="btn btn-outline-secondary"
                  @click="toggle_change_password_type"
                  :aria-label="password_input_type === 'password' ? 'Show password' : 'Hide password'"
                >
                  <i :class="password_input_type === 'password' ? 'bi bi-eye' : 'bi bi-eye-slash'"></i>
                </button>
              </div>
            </div>

            <button class="btn btn-primary w-100 py-2 mb-3 d-inline-flex align-items-center justify-content-center gap-2" :disabled="is_loading">
              Sign in
              <i class="bi bi-arrow-right" aria-hidden="true"></i>
            </button>

            <p class="text-center text-secondary small mb-0">
              Forgot your password?
              <router-link to="/reset_password" class="text-decoration-none fw-semibold text-primary">
                Reset
              </router-link>
            </p>
          </form>
        </div>
      </section>
    </div>
  </div>
</main>
